import React, { FC } from 'react'
import { Modal, Typography } from 'antd-v4'
import { inject } from 'mobx-react'

interface IEnableLocationContentProps {
  content: React.ReactNode
}

const ModalContent: FC<IEnableLocationContentProps> = ({
  content,
}: IEnableLocationContentProps) => {
  const { Paragraph } = Typography
  return <Paragraph className='mt-2 mb-2'>{content}</Paragraph>
}

interface IRetailerConfigModalProps {
  visible: boolean
  configName?: string
  locationName?: string
  enabled?: boolean
  enableContent: React.ReactNode
  disableContent: React.ReactNode
  handleConfirm: () => void
  handleCancel: () => void
}

export const RetailConfigModal: FC<IRetailerConfigModalProps> = inject('currentCompanyStore')(
  ({
    visible,
    configName = '',
    locationName = '',
    enabled,
    enableContent,
    disableContent,
    handleConfirm,
    handleCancel,
  }: IRetailerConfigModalProps) => {
    const modalContent = enabled ? disableContent : enableContent
    return (
      <Modal
        title={`${enabled ? 'Disable' : 'Enable'} BLAZE ECOM: ${locationName}`}
        visible={visible}
        onOk={handleConfirm}
        onCancel={handleCancel}
        okText='Yes'
      >
        <ModalContent content={modalContent} />
      </Modal>
    )
  },
)
